import Vue from 'vue'
import VueMeta from 'vue-meta'

import store from '@/state/store'

import VueRouter from 'vue-router'
import routes from './routes'

Vue.use(VueRouter)
Vue.use(VueMeta, {
    // The component option name that vue-meta looks for meta info on.
    keyName: 'page',
})

const router = new VueRouter({
    routes,
    mode: 'history',
    scrollBehavior (to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return { x: 0, y: 0 }
        }
    },
})

// Before each route evaluates...
router.beforeEach((routeTo, routeFrom, next) => {
    // 檢查是否需要認證
    const requiresAuth = routeTo.matched.some(record => record.meta.requiresAuth !== false)
    const isLoginPage = routeTo.path === '/login'
    
    // 從 cookie 獲取登入狀態
    const loginStatus = document.cookie.split('; ').find(row => row.startsWith('login='))
    const isLoggedIn = loginStatus && loginStatus.split('=')[1] === 'true'
    
    // 如果需要認證但未登入，且不是登入頁，則跳轉到登入頁
    if (requiresAuth && !isLoggedIn && !isLoginPage) {
        next('/login')
    } 
    // 如果已登入但訪問登入頁，則跳轉到首頁
    else if (isLoggedIn && isLoginPage) {
        next('/')
    } 
    // 其他情況正常進行
    else {
        next()
    }
})

router.beforeResolve(async (routeTo, routeFrom, next) => {
    next()
})

export default router

